/**
 * IFS latest document slice (RTK). Root key: IfsLatestDocument.
 */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "@odata.context": null,
  latestIfsDocument: null,
  error: {},
  checkinSuccess: false,
  oneDriveDocumentId: null,
  oneDriveDeleteRequired: false,
  deleteSuccess: false,
  checkinType: null,
  isAllowSelection: false,
};

const ifsLatestSlice = createSlice({
  name: "ifsLatestDocument",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_SEARCH_LATEST_IFS_DOC", (state, action) => {
        const payload = action.payload;
        state.latestIfsDocument =
          payload !== null ? (payload !== "" ? payload : null) : null;
      })
      .addCase("ON_DELETE_ONEDRIVE_DOCUMENT", (state, action) => {
        const p = action.payload;
        state.oneDriveDeleteRequired = p.deleteRequired;
        state.oneDriveDocumentId = p.id;
        state.checkinSuccess = p.checkinSuccess;
        state.checkinType = p.checkinType;
      })
      .addCase("ON_PROCESS_SUCCESS", (state, action) => {
        state.checkinSuccess = action.payload;
      })
      .addCase("ON_DELETE_SUCCESS", (state, action) => {
        state.deleteSuccess = action.payload;
      })
      .addCase("ON_ALLOW_SELECTION", (state, action) => {
        state.isAllowSelection = action.payload;
      });
  },
});

export default ifsLatestSlice;
